import {format, isValid, parse} from "date-fns";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import GarrisonTimelinePrint from "./garrison-timeline-print.jsx";
import GarrisonTimelineMap from "./components/map/garrison-timeline-map.jsx";

const parseFilterDate = (value) => {
  const parsedDate = parse(value, "dd/MM/yyyy HH:mm", new Date());

  return isValid(parsedDate) ? parsedDate : new Date(value);
};

const GarrisonTimelinePrintContent = ({data, filter, zoom, corporation, snapshot, elapsedSeconds, onPrintMapReady}) => {
  const baseStart = parseFilterDate(filter.dtStart);
  const currentDate = new Date(baseStart.getTime() + elapsedSeconds * 1000);
  const pagedData = useMemo(() => ({
    ...data,
    garrisons: data?.garrisons?.map((garrison, index) => ({
      ...garrison,
      originalIndex: index
    })) ?? []
  }), [data]);
  const mapContainerRef = useRef(null);
  const [isMapRendered, setIsMapRendered] = useState(false);
  const [hasReturnedToTop, setHasReturnedToTop] = useState(false);
  const handleMapReady = useCallback(() => setIsMapRendered(true), []);

  useEffect(() => {
    if (!mapContainerRef.current) return;

    mapContainerRef.current.scrollIntoView({block: "center", behavior: "auto"});
    const timer = setTimeout(() => {
      document.getElementById("page-wrapper")?.scrollTo({top: 0, left: 0, behavior: "auto"});
      window.scrollTo({top: 0, left: 0, behavior: "auto"});
      setHasReturnedToTop(true);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isMapRendered && hasReturnedToTop) onPrintMapReady?.();
  }, [hasReturnedToTop, isMapRendered, onPrintMapReady]);

  return (
    <>
      <div id="filters-print" className="transform !-translate-y-[8.5px] text-sm" />
      <div className="mb-6 w-full border-b border-gray-200"/>
      <div className="[&_thead]:!table-row-group">
        <GarrisonTimelinePrint data={pagedData} filter={filter} zoom={zoom}/>
      </div>
      <div className="break-before-page break-inside-avoid w-full">
        <div className="mt-2 mb-2 text-[13px] font-semibold">
          Momento atual no mapa: {format(currentDate, "dd/MM/yyyy HH:mm")}
        </div>
        <div ref={mapContainerRef} className="w-full border border-[#E2E8F0]">
          <GarrisonTimelineMap
            corporation={corporation}
            garrisonsList={pagedData.garrisons}
            snapshot={snapshot}
            filter={filter}
            isPrint={true}
            onPrintReady={handleMapReady}
          />
        </div>
      </div>
    </>
  );
};

export default GarrisonTimelinePrintContent;
